export var DataCatalogRowOperator;
(function (DataCatalogRowOperator) {
    DataCatalogRowOperator["DATA_CATALOG_ROW_OPERATOR_EQ"] = "EQ";
    DataCatalogRowOperator["DATA_CATALOG_ROW_OPERATOR_NE"] = "NE";
    DataCatalogRowOperator["DATA_CATALOG_ROW_OPERATOR_LT"] = "LT";
    DataCatalogRowOperator["DATA_CATALOG_ROW_OPERATOR_LTE"] = "LTE";
    DataCatalogRowOperator["DATA_CATALOG_ROW_OPERATOR_GT"] = "GT";
    DataCatalogRowOperator["DATA_CATALOG_ROW_OPERATOR_GTE"] = "GTE";
    DataCatalogRowOperator["DATA_CATALOG_ROW_OPERATOR_IN"] = "IN";
    DataCatalogRowOperator["DATA_CATALOG_ROW_OPERATOR_NOT_IN"] = "NOT_IN";
    DataCatalogRowOperator["DATA_CATALOG_ROW_OPERATOR_BETWEEN"] = "BETWEEN";
    DataCatalogRowOperator["DATA_CATALOG_ROW_OPERATOR_LIKE"] = "LIKE";
    DataCatalogRowOperator["DATA_CATALOG_ROW_OPERATOR_IS_NULL"] = "IS_NULL";
    DataCatalogRowOperator["DATA_CATALOG_ROW_OPERATOR_IS_NOT_NULL"] = "IS_NOT_NULL";
})(DataCatalogRowOperator || (DataCatalogRowOperator = {}));
